export class ApiError extends Error {
  code: string;
  status: number;

  constructor(message: string, code = "request_failed", status = 500) {
    super(message);
    this.code = code;
    this.status = status;
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData)) headers.set("content-type", "application/json");
  const response = await fetch(path, { ...init, headers, credentials: "same-origin" });
  const data = await response.json().catch(() => null) as { error?: { code?: string; message?: string } } | null;
  if (!response.ok) {
    throw new ApiError(data?.error?.message ?? "処理を完了できませんでした。", data?.error?.code, response.status);
  }
  return data as T;
}
